import { render, staticRenderFns } from "./editCase.vue?vue&type=template&id=1c3148e3&scoped=true"
import script from "./editCase.vue?vue&type=script&lang=js"
export * from "./editCase.vue?vue&type=script&lang=js"
import style0 from "./editCase.vue?vue&type=style&index=0&id=1c3148e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3148e3",
  null
  
)

export default component.exports